import * as React from "react";
import { cn } from "@/lib/utils";

/** Same visual language as Input, but multi-line — client addresses and
 * invoice notes are the first fields in this app that need more than one
 * line. No stack §10b tap-target floor to match (that's an input-height
 * rule); `min-h-20` is just a sane default starting size. */
const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<"textarea">>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        "flex min-h-20 w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";

export { Textarea };
